export default __webpack_public_path__ + "static/promo_1-2111936364877f6d8be14ba40af437fb.webp";